module.exports = ".header {\n  padding: 10px 20px;\n  border-bottom: 1px solid #eeeeee;\n}\n\n.header img {\n  width: 100px;\n  cursor: pointer;\n}\n"